import type { Landmark } from '../../../data/types';
import type { Ring, Vec2 } from '../../../geo/types';
import { vesselOutline, vesselButtressRings } from './churchVessel';
import { arcadePiers } from './cloisterArcade';
import { conventEnclosureRings } from './conventEnclosure';
import { conventRangeRect } from './conventRange';
import { corners } from './genericBlock';
import { toLayout } from './planFrame';
import {
  KARTUIZERS as reading,
  kartuizersFrame,
  kartuizersPartFrame,
  kartuizersChapel,
} from './kartuizersPlan';

/** Actual structures only: the two courts and private gardens stay walkable. */
export function kartuizersFoundations(landmark: Landmark): Ring[] {
  const plan = kartuizersFrame(landmark),
    chapel = kartuizersChapel(),
    cf = kartuizersPartFrame(plan, reading.chapel);
  return [
    ...[vesselOutline(chapel), ...vesselButtressRings(chapel)].map((r) =>
      r.map((p) => toLayout(cf, p))
    ),
    ...[...reading.cells, ...reading.ranges].flatMap((part) => {
      const rect = conventRangeRect(part),
        f = kartuizersPartFrame(plan, part);
      return (
        part.passage
          ? [
              { ...rect, u1: -part.passage / 2 },
              { ...rect, u0: part.passage / 2 },
            ]
          : [rect]
      ).map((r) => corners(r).map((p) => toLayout(f, p)));
    }),
    ...reading.walks.flatMap((w) =>
      arcadePiers({ ...w, front: w.front.map((p) => [p[0]!, p[1]!] as Vec2) as [Vec2, Vec2] }).map(
        (r) => r.map((p) => toLayout(plan, p))
      )
    ),
    ...conventEnclosureRings(reading.walls).map((r) => r.map((p) => toLayout(plan, p))),
  ];
}

export const kartuizersObstacles = kartuizersFoundations;
